import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { TypographyText } from "@portal/BaseComponents/Typography/AntTypography";
import { userConfigAtom } from "@portal/store/userConfig/userConfig";
import { Empty } from "antd";
import { useAtomValue } from "jotai";
import { Fragment } from "react";
import { TitleComponent } from "../Title";
import { ProfileCards } from "../style";

export interface ContactAddressProps {}

const t = {
  ContactAddress: "Contact Address",
};

function ContactAddress(props: ContactAddressProps) {
  const { user_details } = useAtomValue(userConfigAtom);

  function handleIsContactsAvailable() {
    if (!user_details?.customer.address) return;
    return Object.values(user_details?.customer.address).length;
  }

  const isAddressAvailable = handleIsContactsAvailable();
  const EmptyComp = (
    <Empty
      description="No Address available"
      image={Empty.PRESENTED_IMAGE_SIMPLE}
    />
  );
  return (
    <ProfileCards title={<TitleComponent title={t.ContactAddress} />}>
      <Flex vertical align={isAddressAvailable ? "start" : "center"}>
        {isAddressAvailable ? (
          <Fragment>
            <TypographyText>
              {user_details?.customer.address?.address1},&nbsp;
              {user_details?.customer.address?.address2},&nbsp;
              {user_details?.customer.address?.city},&nbsp;
              {user_details?.customer.address?.country}
            </TypographyText>
            <TypographyText>
              {user_details?.customer.address?.state}&nbsp;
              {user_details?.customer.address?.zipcode}
            </TypographyText>
          </Fragment>
        ) : (
          EmptyComp
        )}
      </Flex>
    </ProfileCards>
  );
}

export { ContactAddress };
